import React, { useEffect, useState } from 'react'
import StatsCard from '../../../../components/StatsCard/StatsCard'
import { postApi } from '../../../../api/call.api';
import { dateIntoYYYY_MM_DD } from '../../../../utils/dateTimeConverter';
import { urlApi } from '../../../../api/url.api';

const ChatAnalyticsCards = ({ date, selected }) => {

    const [cardData, setCardData] = useState(null);

    const getData = async () => {
        let postData = {
            filter: selected
        }
        if (selected == 3) {
            postData["startDate"] = dateIntoYYYY_MM_DD(date.startDate);
            postData["endDate"] = dateIntoYYYY_MM_DD(date.endDate);
        }
        let resp = await postApi(postData, urlApi?.chatAnalysisCardsData);
        if (resp.responseCode === 200) {
            setCardData(resp?.data);
        } else {
            setCardData(null);
        }
    }

    useEffect(() => {
        getData()
        return () => {

        }
    }, [date, selected])


    return (
        <div className='grid grid-cols-2 md:grid-cols-5 gap-2 !mb-4'>
            <div>
                <StatsCard title={"Active Chats"} value={cardData?.activeChats || 0} />
            </div>
            <div>
                <StatsCard title={"Total Chats"} value={cardData?.totalChats || 0} />
            </div>
            <div>
                <StatsCard title={"Closed Chats"} value={cardData?.closedChats || 0} />
            </div>
            <div>
                <StatsCard title={"Active Operators"} value={cardData?.activeOperators || 0} />
            </div>
            <div>
                <StatsCard title={"Chats Hour"} value={Math.floor(cardData?.chatHours || 0) + "h"} />
            </div>
        </div>
    )
}

export default ChatAnalyticsCards